import React, { useState, useEffect, Fragment } from "react";
import "./Actions.css";
import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Modal, ModalBody, Row } from "reactstrap";
import admin from "../../assets/images/man_profile.jpg";
import { useDispatch, useSelector} from "react-redux";
import { createApplicationActivity, getPendingTasks, sendReminder, updateTask } from "../../api/Applications";
import { failed, success } from "../../utils/Tostify";
import CustomPagination from "../../components/Pagination/CustomPagination";
import AddTask from "../applications/Tasks/AddTask";
import { deleteTask } from "../../api/Applications";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";
import { getApplicationById } from "../../api/Applications";
import { decryptData } from "../../utils/helper";
import Loader from "../../components/Loader/Loader";
import Tasks from "../activity/Tasks";
import EventTimelineList from "./Timeline";
import { useLocation, useNavigate } from "react-router";
import moment from "moment";
import { editMeeting, getAllMeetings, updateMeeting } from "../../api/meetings";
import RescheduleMeetingModal from "./RescheduleModal";
import { Link } from "react-router-dom";
import { FormControl, MenuItem, Select } from '@mui/material';
import { ActivityDetails, ITEMS_PER_PAGE } from "../../utils/constants";
import { statusTaskOptions } from "../applications/Constant";

function Actions({ ...args }) {
    const location = useLocation();
    const [dropdowntwo, setDropdowntwo] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [expandedApp, setExpandedApp] = useState([]);
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [modelShow, setShowModel] = useState(false);
    const [taskData, setTaskData] = useState({});
    const [applicationData, setApplicationData] = useState({});
    const [applicationNote, setNote] = useState('');
    const [editingApln, setEditingApln] = useState({});
    const [selectedApplication, setSelectedApplication] = useState(null);
    const toggleone = () => setDropdowntwo((prevState) => !prevState);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [openDropdown2Id, setOpenDropdown2Id] = useState(null);
    const [application, setApplication] = useState();
    const allStatuses = ["To Do", "InProgress", "Pending", "Completed"];
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [openTaskForm, setOpenTaskForm] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedMeeting, setSelectedMeeting] = useState(null);
    const [isNoteEmpty, setIsNoteEmpty] = useState(true);
    const [editedDescription, setEditedDescription] = useState("");
    const [events, setEvents] = useState([]);
    const [showSaveIcon, setShowSaveIcon] = useState(false); // Tracks typing to show save icon
    const navigate = useNavigate();
    const [currentDate, setCurrentDate] = useState(new Date());
    let user = useSelector((state) => state?.userReducer?.user);
    const [showReschedule, setShowReschedule] = useState(false);
    const userTimezone = moment.tz.guess(); // Assuming the user's timezone
    const dispatch = useDispatch();
    let token = useSelector((state) => state.userReducer.token);
    const { getConfirmation } = useConfirmDialog();
    const isAdmin =  selectedMeeting?.createdBy?._id === user?._id;
    const clinicId = localStorage.getItem("currentHospitalId"); // Get clinicId from local storage
    const disabledStatus = selectedMeeting?.teamMembers?.filter((member) => user?._id === member?.userId?._id)?.[0]?.status;
    const AllTasks = async () => {
        let res;
        try {
            setIsLoading(true);
            res = await getPendingTasks({dispatch, token, clinicId});
            if (res?.status === "SUCCESS") {
            setData(res?.data);
            setIsLoading(false);
            }else{
            setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        // Set the note as non-empty if the editedDescription is not an empty string
        setIsNoteEmpty(editedDescription.trim() === "");
    }, [editedDescription]);

    useEffect(() => {
        AllTasks();
    }, []);

    const handleExpand = (id) => {
        setExpandedApp((prev) =>
            prev.includes(id) ? prev.filter((appId) => appId !== id) : [...prev, id]
        );
    };

    const handlePagination = (page) => {
        setCurrentPage(page);
    };

    const openRescheduleModal = () => {
        setShowReschedule(true);
      };

      const closeRescheduleModal = () => {
        setShowReschedule(false);
    };

    const toggleDropdown = (taskId) => {
        setOpenDropdownId((prevId) => (prevId === taskId ? null : taskId)); // Toggle for specific row
    };

    const toggleDropdownTwo = (taskId) => {
        setOpenDropdown2Id((prevId) => (prevId === taskId ? null : taskId)); // Toggle for specific row
    };

    const toggleModal = ()=>{
        setShowModel(false);
        setTaskData({});
    };

    const handleRemoveTask = async(AppId,id,appln) =>{
          const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: `Are you sure you want to delete task?`
          });
          if (confirmed) {
              let res;
              try {
                  const values = {applicationId: AppId , taskId: id};
                  setIsLoading(true);
                  res = await deleteTask({values, dispatch, token});
                  if (res?.status === "SUCCESS") {
                      setIsLoading(false);
                      setApplicationData(appln);
                    //   await getApplication();
                      await AllTasks();
                      setSelectedApplication(null);
                      success(res?.message);
                  } else {
                      setIsLoading(false);
                      failed(res?.message);
                  }
              } catch (error) {
                  setIsLoading(false);
                  failed(res?.message);
              }
            }
    };

    const getApplication = async () => {
        let res;
        try {
            setIsLoading(true);
            res = await getApplicationById({ dispatch, token, applicationId: applicationData?._id });
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
            setApplication(responseData);
            setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    useEffect(()=>{
        if(applicationData?._id) {
            getApplication();
        }
    },[applicationData]);

    const transformedTaskData = {
        ...taskData,
        patientId: taskData.patientId?._id,
        assignTo: taskData.assignTo?._id ? taskData.assignTo?._id : taskData.assignTo?._id
    };

    const filteredApplications = data
    .map((app) => {
        const filteredTasks =
        selectedStatuses.includes("All")
            ? app.tasks
            : app.tasks.filter((task) => selectedStatuses.includes(task.status));

        return { ...app, tasks: filteredTasks };
    })
    .filter((app) => app.tasks.length > 0);

    useEffect(() => {
        if (location.state?.selectedStatuses) {
        setSelectedStatuses(location.state.selectedStatuses);
        } else {
        setSelectedStatuses(["All", ...allStatuses]);
        }
    }, [location.state]);

  const handleStatusSelect = (status) => {
    setSelectedStatuses((prevStatuses) => {
      let newStatuses;

      if (status === "All") {
        newStatuses = prevStatuses.includes("All") ? [] : ["All", ...allStatuses];
      } else {
        newStatuses = prevStatuses.includes("All")
          ? allStatuses.filter((s) => s !== status) // Remove "All" and toggle
          : prevStatuses.includes(status)
          ? prevStatuses.filter((s) => s !== status) // Unselect individual
          : [...prevStatuses, status]; // Add new status

        newStatuses = newStatuses.length === allStatuses.length ? ["All", ...allStatuses] : newStatuses;
      }

      return newStatuses;
    });
  };

    const filterTasks = () => {
        if (!searchQuery.trim()) return filteredApplications;

        return filteredApplications.map((app) => ({
          ...app,
          tasks: app?.tasks.filter(
            (task) =>
              task?.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
              `${task?.assignTo?.firstName} ${task?.assignTo?.lastName}`
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
          )
        })).filter(app => app?.tasks?.length > 0);
    };

    const searchedApplications = filterTasks();
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const paginatedApplications = searchedApplications?.slice(startIndex, endIndex);

    const calculatePendingTasks = (tasks) => {
        return tasks.filter((task) => task.status !== "Completed").length;
    };

    const handleApplicationClick = (task,application) => {
        setSelectedApplication(task);
        setSelectedMeeting(null);
        setApplicationData(application);
    };

    const handleNoteChange = (applicationId, value) => {
        setNote((prevState) => ({ ...prevState, [applicationId]: value })); // Update note text for specific patient
    };

    const handleEditClick = (applicationId) => {
        setEditingApln((prevState) => ({ ...prevState, [applicationId]: true })); // Enable editing mode for specific patient
    };

    const handleDeleteNote = async (taskId, payload, applicationId) => {
        const confirmed = await getConfirmation({
            title: "Attention!",
            actionBtnTitle: "Yes",
            message: `Are you sure you want to delete Note?`
        });
        if (confirmed) {
            try {
                setIsLoading(true);
                const updatedPayload = { tasks: { ...payload, editedBy: user?._id, notes: "" } }; // Ensure notes are cleared
                const res = await updateTask({ values: updatedPayload, dispatch, token, applicationId, taskId });
                if (res?.status === "SUCCESS") {
                    setIsLoading(false);
                    // Clear note from state
                    setNote((prevState) => ({ ...prevState, [taskId]: "" }));
                    // Exit edit mode
                    setEditingApln((prevState) => ({ ...prevState, [taskId]: false }));
                    setSelectedApplication((prevState) => ({
                        ...prevState,
                        notes: ""  // Ensure notes are cleared in selectedApplication
                    }));
                    await getApplication(); // Refresh application data
                    success(res?.message);
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(error?.message || "Failed to delete note");
            }
        }
    };

    const handleUpdate = async (taskId, payload, applicationId) => {
        try {
            setIsLoading(true);
            const res = await updateTask({ values: { tasks: payload }, dispatch, token, applicationId, taskId });
            if (res?.status === "SUCCESS") {
                setIsLoading(false);
                // Update note state
                setNote(prevState => ({ ...prevState, [taskId]: payload.notes }));
                setEditingApln(prevState => ({ ...prevState, [taskId]: false }));
                // Ensure delete icon appears immediately
                setSelectedApplication(prev => ({
                    ...prev,
                    notes: payload.notes
                }));
                await getApplication(); // Refresh application data
                success(res?.message);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(error?.message || "Failed to update note");
        }
    };

    const handleMeetingClick = (event)=>{
        setSelectedApplication(null);
        setSelectedMeeting(event);
    };

    const handleStatusMeeting = async(status)=>{
        if (!selectedMeeting || !selectedMeeting.teamMembers) {
            return;
          }
          const eventData = {
            teamMembers: [
              // Update the selected user's status
              ...selectedMeeting.teamMembers
                .filter((member) => member.userId && member.userId._id === user?._id)
                .map((member) => ({
                  userId: member.userId._id,
                  status: status
                })),
              // Keep the other team members unchanged
              ...selectedMeeting.teamMembers
                .filter((member) => member.userId && member.userId._id !== user?._id).map((member) => ({
                    userId: member.userId._id,
                    status: member.status
                  }))
            ]
          };
            let res;
            try {
              setIsLoading(true);
              res = await editMeeting({ values: {...eventData, eventId : selectedMeeting?._id}, dispatch, token });
              if (res?.status == "SUCCESS") {
                await getMeeting();
                setIsLoading(false);
                success(res?.message);
              }else{
                setIsLoading(false);
                failed(res?.message);
              }
          } catch (error) {
              setIsLoading(false);
              failed(res?.message);
          }
    };

    useEffect(() => {
        setEditedDescription(selectedMeeting?.description || "");
        setShowSaveIcon(false);
    }, [selectedMeeting]);

    const handleInputChange = (e) => {
        setEditedDescription(e.target.value);
        setShowSaveIcon(true);
    };

    const getMeeting = async()=>{
        let res;
        const values = {
            orgId: localStorage.getItem("currentOrgId"),
            clinicId: localStorage.getItem("currentHospitalId"),
            date: moment(selectedMeeting?.date).tz(moment.tz.guess()).startOf("day").utc()
        };
        res = await getAllMeetings({ values, dispatch, token });
        const responseData = decryptData(res?.data);
        const meeting = responseData?.filter(item => item?._id === selectedMeeting?._id);
        if (meeting && meeting[0]) {
            const selectedEvent = meeting[0];
            // Handle the 'fromTime' and 'toTime' conversion
            const updatedMeeting = {
                ...selectedEvent,
                fromTime: moment.utc(selectedEvent.fromTime).tz(userTimezone), // Convert to UTC if 'fromTime' exists
                toTime: moment.utc(selectedEvent.toTime).tz(userTimezone) // Convert to UTC if 'toTime' exists
            };
            // Set the updated meeting with converted 'fromTime' and 'toTime'
            setSelectedMeeting(updatedMeeting);
        }
    };

    const getDateWiseMeetings = async (selectedDate) => {
        let res;
        try {
          setIsLoading(true);
          const localDate = moment(selectedDate).tz(moment.tz.guess()).startOf("day").utc(); // Convert to local timezone and start of the day
          const values = {
            orgId: localStorage.getItem("currentOrgId"),
            clinicId: localStorage.getItem("currentHospitalId"),
            date: localDate // Convert to UTC for backend
          };

          res = await getAllMeetings({ values, dispatch, token });
          const responseData = decryptData(res?.data);
          if (res?.status === "SUCCESS") {
            const updatedEvents = responseData.map((event) => {
              return {
                ...event,
                date: moment.utc(event.date).tz(moment.tz.guess()).format("YYYY-MM-DD"),
                fromTime: moment.utc(event.fromTime).tz(moment.tz.guess()), // Keep as moment object
                toTime: moment.utc(event.toTime).tz(moment.tz.guess())     // Keep as moment object
              };
            });
            setEvents(updatedEvents);
            const meeting = responseData?.filter(item => item?._id === selectedMeeting?._id);
                if (meeting && meeting[0]) {
                    const selectedEvent = meeting[0];
                    const updatedMeeting = {
                        ...selectedEvent,
                        date: moment.utc(selectedEvent.date).tz(moment.tz.guess()).format("YYYY-MM-DD"),
                        fromTime: moment.utc(selectedEvent.fromTime).tz(userTimezone),
                        toTime: moment.utc(selectedEvent.toTime).tz(userTimezone)
                    };
                    setSelectedMeeting(updatedMeeting);
                }
                }
        } catch (error) {
          failed(res?.message);
        } finally {
          setIsLoading(false);
        }
      };

    const handleSaveNoteClick = async () => {
        let res;
        try {
            setIsLoading(true);
            const payload = { description: editedDescription };
            res = await updateMeeting({ values: payload, token, meetingId: selectedMeeting._id });

            if (res?.status === "SUCCESS") {
                success(res?.message);
                await getMeeting();
                //on 21 feb
                await getDateWiseMeetings(currentDate);
                setShowSaveIcon(false);
                setIsNoteEmpty(false);
            }
        } catch (error) {
            failed(res?.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleEditNoteClick = () => {
        setShowSaveIcon(false);
    };

    const handleDeleteNoteClick = async () => {

        const confirmed = await getConfirmation({
            title: "Attention!",
            actionBtnTitle: "Yes",
            message: `Are you sure you want to delete Note?`
        });
        let res;
        if (confirmed) {
            try {
                setIsLoading(true);
                const payload = { description: "" };
                res = await updateMeeting({ values: payload, token, meetingId: selectedMeeting._id });
                if (res?.status === "SUCCESS") {
                    success(res?.message);
                    const values = {
                        orgId: localStorage.getItem("currentOrgId"),
                        clinicId: localStorage.getItem("currentHospitalId"),
                        date: moment(selectedMeeting?.date).format("YYYY-MM-DD")
                    };
                    res = await getAllMeetings({ values, dispatch, token });
                    const responseData = decryptData(res?.data);
                    const meeting = responseData?.filter(item => item?._id === selectedMeeting?._id);
                    //ON 21 FEB
                    await getDateWiseMeetings(currentDate);
                    setSelectedMeeting(meeting[0]);
                    setShowSaveIcon(false);
                    setIsNoteEmpty(true); // Set note as empty after deletion
                    setIsLoading(false);
                }
              } catch (error) {
                setIsLoading(false);
                failed(res?.message);
              }
        }
    };

    const handleSendReminder = async (task, applicationId) => {
        try {
            setIsLoading(true);
            const values = {taskId: task._id, applicationId };
            const res = await sendReminder({ values,token, dispatch});
            if (res?.status === "SUCCESS") {
                success(res?.message);
                setIsLoading(false);
            } else {
                failed(res?.data?.message || "Failed to send reminder.");
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            failed("Error sending reminder.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveClick = async(taskId,applnId ,data) =>{
        let res;
        try {
          const payload = {tasks : data  };
          setIsLoading(true);
          res = await updateTask({values:payload, dispatch, token, applicationId: applnId, taskId: taskId});
          if (res?.status === "SUCCESS") {
            let values = {
              type : "Application",
              event : ActivityDetails?.TaskCreationUpdate?.event,
              applicationId : application?._id,
              clinicId: localStorage.getItem("currentHospitalId"),
              organizationId: localStorage.getItem("currentOrgId"),
              patientId : application?.patientData?._id ,
              details : "Task status changed."
            };
            await createApplicationActivity({ values, dispatch, token });
            // await getApplication();
            await AllTasks();
            setIsLoading(false);
            success(res?.message);
          }
        } catch (error) {
          failed(res?.message);
          setIsLoading(false);
        }
    };

    const formatSelectedStatuses = (statuses) => {
        const formattedStatuses = statuses.map((status) =>
            status === "Pending" ? "Pending Verification" : status
        );

        if (formattedStatuses.length === 0) return "";

        const first = formattedStatuses[0].slice(0, 16); // First 12 characters
        return formattedStatuses.length > 1 ? `${first}...` : first;
    };


    return (
        <Fragment>
        <div className="actions_container organization_blk d-block">
            {isLoading ? <Loader /> : null}

            <Row>
                <Col xl={7} className="mb-3">
                <div className="left_side_action_container">
                            <div className="left_side_action main-header-block">

                                <div className="d-flex align-items-center mb-3 justify-content-between gap-3 flex-wrap">
                                    <div className="">
                                        <h2 className="home-title m-0">Task List</h2>
                                    </div>
                                    <div className="">
                                        <Form className="form_block" onSubmit={(e) => e.preventDefault()}>
                                            <FormGroup>
                                                <Input
                                                    id="exampleSearch"
                                                    name="search"
                                                    placeholder="Task name or Assignee"
                                                    type="search"
                                                    value={searchQuery}
                                                    onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                                                />
                                                {/* <i className="fa fa-search"></i> */}
                                            </FormGroup>
                                        </Form>
                                    </div>
                                    <div className="">
                                        <div className="d-flex gap-2 align-items-center justify-content-end">
                                            <Dropdown isOpen={dropdowntwo} toggle={toggleone}>
                                                <DropdownToggle caret size="xl" className="column_blk">
                                                    {selectedStatuses.includes("All") ? "All" : formatSelectedStatuses(selectedStatuses)}
                                                    <i className="fa fa-caret-down"></i>
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem onClick={(e) => e.stopPropagation()}>
                                                        <div onClick={(e) => e.stopPropagation()}>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedStatuses.includes("All")}
                                                                readOnly
                                                                onChange={() => handleStatusSelect("All")}
                                                            />
                                                            All
                                                        </div>
                                                    </DropdownItem>
                                                    {allStatuses.map((status) => (
                                                        <DropdownItem key={status} onClick={(e) => e.stopPropagation()}>
                                                            <div onClick={(e) => e.stopPropagation()}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedStatuses.includes(status)}
                                                                    readOnly
                                                                    onChange={() => handleStatusSelect(status)}
                                                                />
                                                                {status === "Pending" ? "Pending Verification" : status}
                                                            </div>
                                                        </DropdownItem>
                                                    ))}
                                                </DropdownMenu>
                                            </Dropdown>
                                            <button
                                                className="add_notes p-0"
                                                onClick={() => setOpenTaskForm(true)}
                                            >
                                                <i className="fa fa-plus"></i> Add Task
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="table_space">
                                    <div className="table-responsive">
                                        <table>
                                            <thead>
                                            </thead>
                                            <tbody>
                                                {paginatedApplications?.length > 0 ? paginatedApplications?.map((appln) => (
                                                    <>
                                                        <tr>
                                                            <td colSpan={9} height={5} className="bg_light"></td>
                                                        </tr>
                                                        <tr
                                                            className="first_block">
                                                            <td className="check_in"
                                                                onClick={() => handleExpand(appln?._id)}
                                                            >
                                                                <i
                                                                    className={
                                                                        expandedApp.includes(appln?._id)
                                                                            ? "fas fa-caret-down"
                                                                            : "fas fa-caret-right"
                                                                    }
                                                                ></i>
                                                            </td>
                                                            <td>
                                                                <Link
                                                                    to={"/app/application-detail"}
                                                                    className="d-flex flex-column gap-1"
                                                                    state={{ applicationData: appln }}
                                                                >
                                                                    <h6>{appln.title} - {decryptData(appln?.patientData?.name[0].text)} - {appln.applicationID}</h6>
                                                                </Link>
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>
                                                                <button className="pending_blk">
                                                                    Pending Tasks:{" "}
                                                                    {calculatePendingTasks(appln.tasks).toString().padStart(2, "0")}
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                        <td colSpan={9} className="p-0">
                                                            {/* The CSS written under the 'table responsive' class is for opening the dropdown. */}
                                                                <div className="table-responsive" style={{
                                                                    overflow: openDropdownId ? "visible" : "scroll",
                                                                    position: "relative",
                                                                    zIndex: 1
                                                                }}>
                                                            <table>
                                                                <tbody>
                                                                {expandedApp.includes(appln?._id) && <tr className="header_table">
                                                            <th>
                                                            </th>
                                                            <th>
                                                                Task Name
                                                            </th>
                                                            <th>
                                                                Assigned To
                                                            </th>
                                                            <th>
                                                                Created By
                                                            </th>
                                                            <th>
                                                                Edited By
                                                            </th>
                                                            <th>
                                                                Status
                                                            </th>
                                                            <th>
                                                                Created
                                                            </th>
                                                            <th>
                                                                Due Date
                                                            </th>
                                                            <th></th>
                                                        </tr>}
                                                        {expandedApp.includes(appln?._id) && (appln.tasks.map((task, index) => (
                                                            <tr
                                                                onClick={(e) => {
                                                                    if (!e.target.closest(".dropdown-menu") && !e.target.closest(".drop_blk")) {
                                                                        handleApplicationClick(task, appln);
                                                                    }
                                                                }}
                                                                className={`onclick_data ${selectedApplication?._id === task._id ? 'highlighted' : ''} ${index % 2 === 0 ? 'row-light-blue' : 'row-light-gray'
                                                                    }`}
                                                                key={task._id || index}
                                                            >
                                                                <td className="check_in"> <i
                                                                    className={`fa ${task?.status === "Completed" ? "fa-check-circle" : "fa-info-circle"
                                                                        }`}
                                                                ></i>
                                                                </td>
                                                                <td>{task.title}</td>
                                                                <td>{task.assignTo?.firstName} {task.assignTo?.lastName || ''}</td>
                                                                <td>{task?.createdBy?.firstName} {task.createdBy?.lastName}</td>
                                                                <td>{task.editedBy?.firstName} {task.editedBy?.lastName || ''}</td>
                                                                <td className="p-0 upload_blk">
                                                                    <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                                                                        <Select
                                                                            labelId="demo-select-small-label"
                                                                            id="demo-select-small"
                                                                            value={task?.status}
                                                                            defaultValue={task?.status}
                                                                            onChange={(e) => handleSaveClick(task._id, appln?._id, { "status": e.target.value })} // Assign staff to this patient
                                                                        >
                                                                            {statusTaskOptions?.map((option) => (
                                                                                <MenuItem key={option.value} value={option.value}>
                                                                                    {option.label}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                </td>
                                                                <td>{moment(task.createdAt).format('MM-DD-YYYY')}</td>
                                                                <td>{task.dueDate || 'N/A'}</td>
                                                                <td>
                                                                    <Dropdown
                                                                        isOpen={openDropdownId === task._id}
                                                                        toggle={() => toggleDropdown(task._id)}
                                                                        direction="down"
                                                                    >
                                                                        <DropdownToggle caret size="xl" className="drop_blk">
                                                                            <div className="for_details">
                                                                                <i className="fa fa-ellipsis-v"></i>
                                                                            </div>
                                                                        </DropdownToggle>
                                                                        <DropdownMenu {...args}>
                                                                            <DropdownItem onClick={() => { setShowModel(true); setTaskData(task); setApplicationData(appln); }} className="d-flex gap-2 drop_block_content align-items-center">
                                                                                <div className="add_hosp">Edit Task</div>
                                                                            </DropdownItem>
                                                                            <DropdownItem onClick={() => handleSendReminder(task, appln._id)} className="d-flex gap-2 drop_block_content align-items-center">
                                                                                <div className="add_hosp">
                                                                                    Send Reminder
                                                                                </div>
                                                                            </DropdownItem>
                                                                            <DropdownItem onClick={() => { handleRemoveTask(appln?._id, task?._id, appln); }} className="d-flex gap-2 drop_block_content align-items-center">
                                                                                <div className="add_hosp">Delete Task</div>
                                                                            </DropdownItem>
                                                                        </DropdownMenu>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        ))
                                                        )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        </td>
                                                        </tr>
                                                    </>
                                                ))
                                                    : <tr><td colSpan="8">No Data Found</td></tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                    {modelShow && (
                                        <AddTask
                                            isOpen={modelShow}
                                            application={application}
                                            getApplication={getApplication}
                                            AllTasks={AllTasks}
                                            toggle={toggleModal}
                                            taskData={transformedTaskData}
                                        />)}
                                    <Modal isOpen={openTaskForm} toggle={() => setOpenTaskForm(false)} size="lg">
                                        <ModalBody>
                                            <Tasks getApplication={getApplication} AllTasks={AllTasks} onTaskCreated={setSelectedApplication} setOpenTaskForm={() => setOpenTaskForm(false)} />
                                        </ModalBody>
                                    </Modal>
                                    <CustomPagination
                                        totalPages={Math.ceil(filteredApplications?.length / ITEMS_PER_PAGE)}
                                        totalRows={searchedApplications?.length}
                                        rowsPerPage={ITEMS_PER_PAGE}
                                        page={currentPage}
                                        handlePage={handlePagination}
                                    />
                                </div>
                            </div>
                {selectedApplication &&  !selectedMeeting && (
                    <div className="bottom_side_action">
                    <div className="left_header d-flex justify-content-between align-items-center">
                        <div>
                            <h5>Task Details</h5>
                            <Link
                                to={"/app/application-detail"}
                                state={{ applicationData: paginatedApplications?.filter(item=>item?._id === selectedApplication?.applicationId)?.[0] }}
                            >
                                Application Title :  {applicationData?.title}
                            </Link>
                        </div>
                        <div className="d-flex align-items-center button_block">
                            <Dropdown
                                isOpen={openDropdown2Id === selectedApplication._id}
                                toggle={() => toggleDropdownTwo(selectedApplication._id)}
                                direction="down"
                            >
                                <DropdownToggle caret size="xl" className="drop_blk">
                                        <div className="for_details">
                                            <i className="fa fa-ellipsis-v"></i>
                                        </div>
                                </DropdownToggle>
                                <DropdownMenu {...args}>
                                    <DropdownItem onClick={()=> {setShowModel(true);setTaskData(selectedApplication);}} className="d-flex gap-2 drop_block_content align-items-center">
                                        <div className="add_hosp">Edit Task</div>
                                    </DropdownItem>
                                    <DropdownItem onClick={()=>handleRemoveTask(applicationData?._id,selectedApplication?._id)} className="d-flex gap-2 drop_block_content align-items-center">
                                        <div className="add_hosp" >Delete Task</div>
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                    <div className="d-flex  profile_con">
                        <div className="profile">
                            <div className="admin_profile">
                                <img src={admin} alt="" />
                                <div className="d-flex flex-column gap-2">
                                    <p className="title_name m-0">Created by:</p>
                                    <h4 className="title_admin m-0">Admin</h4>
                                    <p className="title_name m-0">
                                        {selectedApplication.editedBy?.firstName} {selectedApplication.assignedBy?.lastName || ''}
                                    </p>
                                </div>
                            </div>
                            <div className="patient_profile">
                                <img src={admin} alt="" />
                                <div>
                                    <p className="title_name">Assigned to:</p>
                                    <h4 className="title_admin">Patient</h4>
                                    <p className="title_name">
                                    {selectedApplication.assignTo?.firstName} {selectedApplication.assignTo?.lastName || ''}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="follow_up_block">
                            <div className="d-flex justify-content-between flex-wrap gap-2 mb-2">
                            <h2>
                            <Link to={`/app/application-detail`}
                                state={{applicationData : paginatedApplications?.filter(item=>item?._id === selectedApplication?.applicationId)?.[0], activeTab:"5"}}
                            >
                                Task Title :  {selectedApplication.title}
                            </Link>
                            </h2>
                            <button className="add_notes">
                                {selectedApplication?.status}
                            </button>
                            </div>
                            <h6>Note:</h6>
                            <div className="d-flex gap-3 mb-3 align-items-center">
                            <Form className="text_block flex-grow-1">
                                <Input
                                    id="exampleText"
                                    name="text"
                                    type="textarea"
                                    className="text_area_blk"
                                    value={applicationNote[selectedApplication._id] ?? selectedApplication?.notes ?? ''}
                                    onChange={(e) => {
                                        handleNoteChange(selectedApplication._id, e.target.value);
                                    }}
                                    onClick={() => handleEditClick(selectedApplication._id)}
                                />
                            </Form>
                            <div className="d-flex gap-3">
                                {(applicationNote[selectedApplication._id] !== undefined &&
                                    applicationNote[selectedApplication._id] !== selectedApplication?.notes &&
                                    editingApln[selectedApplication._id]) ? (
                                    <i
                                        className="fa fa-floppy-disk"
                                        onClick={() => {
                                            handleUpdate(
                                                selectedApplication._id,
                                                { ...taskData, notes: applicationNote[selectedApplication._id] },
                                                application._id,
                                                selectedApplication?.patientData?._id
                                            );
                                            setEditingApln((prevState) => ({ ...prevState, [selectedApplication._id]: false })); // Reset to edit mode
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    />
                                ) : (
                                    <i
                                        className="fa fa-edit"
                                        onClick={() => handleEditClick(selectedApplication._id)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                )}
                                {selectedApplication?.notes?.trim() !== "" && (
                                    <i
                                        className="fas fa-trash-alt"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() =>
                                            handleDeleteNote(
                                                selectedApplication._id,
                                                { ...taskData, notes: "" },
                                                application._id,
                                                selectedApplication?.patientData?._id
                                            )
                                        }
                                    />
                                )}
                            </div>
                            </div>
                            </div>
                    </div>
                </div>
                )}
                {selectedMeeting && !selectedApplication &&
                    <div className="bottom_side_action">
                        <div className="d-flex justify-content-between">
                        <h4>
                        {!isAdmin ? (
                            <>
                            Meeting Invitation {disabledStatus === "Accepted" && "(Accepted)"}
                            </>
                        ) : (
                            "Meeting Details"
                        )}
                        </h4>
                        {!isAdmin ? (
                            <>
                            <div>
                                {disabledStatus !== "Accepted" &&
                                <button
                                type="button"
                                className="accept-btn"
                                onClick={() => handleStatusMeeting("Accepted")}
                                >
                                {disabledStatus === "Accepted" ? "Accepted" : "Accept"}
                                </button>}
                                {disabledStatus !== "Declined" &&
                                <button
                                type="button"
                                className="decline-btn"
                                onClick={() => handleStatusMeeting("Declined")}
                                >
                                Decline
                                </button>}
                            </div>
                            </>
                            ) : (
                                <>
                                <div className="d-flex justify-content-end gap-4">
                                <button className="add_notes" onClick={openRescheduleModal}>
                                Reschedule
                                </button>
                                </div>
                                </>
                            )}
                        </div>
                        <div className="d-flex  profile_con">
                            <div className="profile">
                                <div className="admin_profile">
                                    <img src={admin} alt="" />
                                    <div>
                                        <h4 className="title_admin">Admin</h4>
                                        <p className="title_name">{selectedMeeting?.createdBy?.firstName+ " "+ selectedMeeting?.createdBy?.lastName}</p>
                                    </div>
                                </div>
                                <div className="patient_profile">
                                    <img src={admin} alt="" />
                                    <div>
                                        <h4 className="title_admin">Patient</h4>
                                        <p className="title_name">{selectedMeeting?.patient?._id?.name[0]?.text && decryptData(selectedMeeting?.patient?._id?.name[0]?.text)}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="follow_up_block">
                            <div className="d-flex justify-content-between mb-2">
                            <h2>{selectedMeeting.eventTitle}</h2>
                            </div>
                                <div className="invitees_block">
                                    <div className="d-flex align-items-center gap-3">
                                    <div className="">
                                        <h6>Invitees:</h6>
                                        {
                                        selectedMeeting?._id && selectedMeeting.teamMembers.map(item => {
                                            let iconClass, colorClass;

                                            // Determine icon and color class based on status for team members
                                            if (item.status === 'Accepted') {
                                            iconClass = 'fa-check-circle';
                                            colorClass = 'text-success';
                                            } else if (item.status === 'Declined') {
                                            iconClass = 'fa-times-circle';
                                            colorClass = 'text-danger';
                                            } else {
                                            iconClass = 'fa-question-circle';
                                            colorClass = 'text-warning';
                                            }
                                            return (
                                                <>
                                                <div key={item._id}>
                                                  <div className="">
                                                    <h6>
                                                      <i className={`fa ${iconClass} ${colorClass}`} />
                                                      {item.userId?.firstName} {item.userId?.lastName}
                                                    </h6>
                                                  </div>
                                        </div></>);})}
                                    </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-3">
                                        <p>{moment(selectedMeeting.fromTime, "HH:mm").format("h:mmA")} - {moment(selectedMeeting.toTime, "HH:mm").format("h:mmA")}, {moment(selectedMeeting.date).format("MMM D")}</p>
                                        <p>|</p>
                                        <p>Created: {moment(selectedMeeting?.createdAt).format("MMMM D, YYYY h:mmA")}</p>
                                    </div>
                                </div>
                                <h6>Note:</h6>
                                <div className="d-flex align-items-center gap-3">
                                    <div className="note_block">
                                        <Form className="text_block flex-grow-1">
                                            <Input
                                                className="text_area_blk"
                                                value={editedDescription}
                                                onChange={handleInputChange}
                                                placeholder="Type your note..."
                                                autoFocus
                                            />
                                        </Form>
                                    </div>
                                    <div className="d-flex flex-column gap-2">
                                        {showSaveIcon ? (
                                            <i className="fa fa-save" onClick={handleSaveNoteClick} style={{ cursor: "pointer" }}></i>
                                        ) : (
                                            <i className="fa fa-edit" onClick={handleEditNoteClick} style={{ cursor: "pointer" }}></i>
                                        )}
                                        {!isNoteEmpty && (
                                            <i className="fas fa-trash-alt" onClick={handleDeleteNoteClick} style={{ cursor: "pointer" }}></i>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
                </Col>
                <Col xl={5} className="mb-3">
            <div className="right_side_action">
                <div className="d-flex justify-content-between align-items-center">
                    <h3>Upcoming Meetings</h3>
                    <a><i className="fa-solid fa-calendar" style={{ fontSize: "22px", color :"#335FFC" ,cursor:"pointer" }} onClick={()=>navigate("/clinic/calendar")}></i></a>
                </div>
                <div className="mt-2">
                <h5>Meetings</h5>
                </div>
                <EventTimelineList setSelectedMeeting={handleMeetingClick}
                    currentDate={currentDate}
                    setCurrentDate={setCurrentDate}
                    events={events}
                    setEvents={setEvents}
                    getDateWiseMeetings={getDateWiseMeetings}
                />
                <RescheduleMeetingModal
                    meeting={selectedMeeting}
                    isLoading={isLoading}
                    show={showReschedule}
                    onHide={closeRescheduleModal}
                    onReschedule={getDateWiseMeetings}
                    setIsLoading={setIsLoading}
                />
            </div>
                </Col>
            </Row>

        </div>
        </Fragment>
    );
}

export default Actions;
